export default __webpack_public_path__ + "static/media/NFO_passcode_banner.787d0170.jpg";